import { useMemo, useState } from 'react';

import { NOT_ASSIGNED_USER } from '@/features/header/consts/user';
import { useAuth } from '@/hooks/useAuth';
import { selectUser, useAuthStore } from '@/stores/useAuthStore';
import { useOrganization } from '@clerk/react';

/** Safe wrapper — returns undefined when rendered outside ClerkProvider (mock mode). */
function useSafeOrganization() {
  try {
    return useOrganization();
  } catch {
    return { organization: undefined };
  }
}

export const useUserTile = () => {
  const [open, setOpen] = useState(false);

  const user = useAuthStore(selectUser);
  const { organization } = useSafeOrganization();

  const { logout } = useAuth();

  const handleLogout = () => {
    setOpen(false);
    logout();
  };

  const initials = useMemo(() => {
    if (!user) return NOT_ASSIGNED_USER.initials;
    const parts = user.Name.trim().split(' ');
    return parts
      .map((p) => p[0]?.toUpperCase())
      .filter(Boolean)
      .slice(0, 2)
      .join('');
  }, [user?.Name]);

  const userName = user?.Name ?? NOT_ASSIGNED_USER.Name;
  const companyName = organization?.name ?? 'Mock Company';

  return { open, setOpen, userName, companyName, initials, handleLogout };
};
